import { render } from "./MenuLeft.vue?vue&type=template&id=4a9f1a68"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"

import "./MenuLeft.vue?vue&type=style&index=0&id=4a9f1a68&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__